import axios from 'axios'

// In fetchData.js
export const fetchData = async (comparisonID, setData, setLoadingStatus) => {
    try {
      const compResponse = await fetch(`${process.env.REACT_APP_RESULTS_DATA}comp/${comparisonID}`);
      const comp = await compResponse.json();
      const splitResponse = await fetch(`${process.env.REACT_APP_SPLIT_RESULTS}/${comp.resultsID}`);
      const split = await splitResponse.json();
      const resultsData = typeof split.data === 'string' ? JSON.parse(split.data) : split.data;
  
      const newData = {
        results: resultsData.results,
        claimData: comp.claimData,
        files: comp.files,
        headers: comp.headers,
        resultsID: comp.resultsID,
        dateUploaded: comp.dateUploaded,
        statusMSG: comp.statusMSG,
        status: comp.status,
        doc1_name: comp.doc1_name,
        doc2_name: comp.doc2_name,
        compID: comp.compID,
        headersOne: comp.headersOne,
        headersTwo: comp.headersTwo,
        missingOne: comp.missingOne,
        missingTwo: comp.missingTwo,
        cleanParsedEstData: comp.cleanParsedEstData,
        cleanParsedInsData: comp.cleanParsedInsData,
        estPriceList: comp?.estPriceList,
        insPriceList: comp?.insPriceList
      };
  
      setLoadingStatus('');
      setData(newData);
    } catch (err) {
      console.error('Error fetching results data:', err);
      setLoadingStatus('Error loading data');
    }
  };
  